import { Component, Vue } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class Freight extends Vue {
  tableData: object[] = [];
  cpCode: number | string = null;
  cpList: any[] = [];
  isHighPriceLogistics: boolean = false;

  created() {
    this.getCpList();
  }

  getCpList() {
    Axios.getSecret("/api/common/logistics/all").then((res) => {
      this.cpList = res.data.data.filter((item) => item.cpCode !== "default");
      this.cpCode = this.cpList[0].cpCode;
      this.getList();
    });
  }
  getLogisticsConfig(cpCode) {
    Axios.getSecret("/api/common/isHighPriceLogistics", { cpCode }).then(
      (res) => {
        if (res.data.status == 200) {
          if (res.data.data === 1) {
            this.isHighPriceLogistics = true;
          } else {
            this.isHighPriceLogistics = false;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }
    );
  }
  getList() {
    this.$api.getfreightTemplateList({ cpCode: this.cpCode }).then((res) => {
      if (res.data.status == 200) {
        this.tableData = res.data.data;
      }
    });
    this.getLogisticsConfig(this.cpCode);
  }
  onSubmit(idx: string) {
    this.$confirm("是否提交修改？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let data = JSON.parse(JSON.stringify(this.tableData[idx]));
        delete data.region;
        this.$api.changeFreightData(data).then((res) => {
          if (res.data.status == 200) {
            this.getList();
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消",
        });
      });
  }
  onChange(value) {
    Axios.postByJson("/api/common/updateHighPriceLogistics", {
      cpCode: this.cpCode,
      highPriceLogistics: value ? 1 : 0,
    }).then((res) => {
      if (res.data.status === 200) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    });
  }
}
